import { Role } from './role'

export enum StaffSection {
  IS = 'IS',
  CS = 'CS'
}

export interface StaffMember {
  id: string
  fullname: string
  email: string
  language: string
  role_id: number
  section?: StaffSection
  phone_number: string
  restrictions: StaffMemberRestrictions
  created_at: Date
  updated_at: Date
  deactivated_at?: Date
  user_type: Role
  relationships?: any
}

export interface StaffMemberRestrictions {
  allowed_days: string
  allowed_start_time: string
  allowed_end_time: string
  allowed_ip_ranges: string[]
  allowed_countries: string[]
}
